export type PluginOs = 'windows' | 'macos' | 'linux' | 'linux_arm64';

export type PluginDownloadSurface =
  | 'plugin_page'
  | 'plugin_benefits'
  | 'plugin_download_page'
  | 'plugin_download_modal';

export const PLUGIN_GITHUB_URL = 'https://github.com/tone-3000/tone3000-plugin';

export const PLUGIN_VERSION = '0.0.12';

export const PLUGIN_DOWNLOADS: Record<
  PluginOs,
  { os: PluginOs; label: string; url: string }
> = {
  windows: {
    os: 'windows',
    label: 'Windows',
    url: `https://github.com/tone-3000/tone3000-plugin/releases/download/v${PLUGIN_VERSION}/TONE3000-v${PLUGIN_VERSION}-windows-x64.exe`,
  },
  macos: {
    os: 'macos',
    label: 'Mac',
    url: `https://github.com/tone-3000/tone3000-plugin/releases/download/v${PLUGIN_VERSION}/TONE3000-v${PLUGIN_VERSION}-macos-universal.pkg`,
  },
  linux: {
    os: 'linux',
    label: 'Linux',
    url: `https://github.com/tone-3000/tone3000-plugin/releases/download/v${PLUGIN_VERSION}/TONE3000-v${PLUGIN_VERSION}-linux-x64.tar.gz`,
  },
  linux_arm64: {
    os: 'linux',
    label: 'Linux ARM64',
    url: `https://github.com/tone-3000/tone3000-plugin/releases/download/v${PLUGIN_VERSION}/TONE3000-v${PLUGIN_VERSION}-linux-aarch64.tar.gz`,
  },
};

export const PLUGIN_OS_ORDER: PluginOs[] = ['windows', 'macos', 'linux', 'linux_arm64'];

/** Defaults to Mac so SSR and the first paint match. */
export function detectPluginOs(): PluginOs {
  if (typeof navigator === 'undefined') return 'macos';
  const ua = navigator.userAgent;
  if (/Mac|iPhone|iPad|iPod/.test(ua)) return 'macos';
  if (/Linux/.test(ua) && !/Android/.test(ua)) return 'linux';
  if (/Win/.test(ua)) return 'windows';
  return 'macos';
}
